import { post, get } from "../../api";
import { authHeader } from "../../utils";

const mybagGuest = body => post("mybagGuest", {}, body);
const mybagApiData = () => get("mybag", { ...authHeader() });

export { mybagGuest, mybagApiData };
